import React from "react";

const CheckIcon = ({ color = "#5D5D5D" }) => {
  return (
    <svg
      width="13"
      height="9"
      viewBox="0 0 13 9"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M12.7279 0.263519C12.9021 0.432301 13 0.661188 13 0.899846C13 1.1385 12.9021 1.36739 12.7279 1.53617L5.29267 8.73648C5.11838 8.90521 4.88203 9 4.63559 9C4.38914 9 4.15279 8.90521 3.9785 8.73648L0.260894 5.13633C0.0915959 4.96658 -0.00208243 4.73923 3.51338e-05 4.50324C0.0021527 4.26725 0.0998969 4.04151 0.272215 3.87464C0.444534 3.70776 0.677639 3.61311 0.921325 3.61106C1.16501 3.609 1.39978 3.69972 1.57507 3.86367L4.63559 6.8275L11.4137 0.263519C11.588 0.094788 11.8244 0 12.0708 0C12.3172 0 12.5536 0.094788 12.7279 0.263519Z"
        fill="#B1B1B1"
      />
    </svg>
  );
};

export default CheckIcon;
